import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Modal, Button } from "react-bootstrap";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import './card.scss';
// ── Contact details for Company Nannies ──────────────────────────────────────
const COMPANY_NANNIES_CONTACT = {
  email: "info@nanny-line.com",
  whatsapp: "+34617243659",       // digits only, used in wa.me link
  phone: "+34617243659",
};

const Card = ({ name, image, categoryId, price }) => {
  const navigate = useNavigate();
  const [showContact, setShowContact] = useState(false);

  const navigateToAnotherScreen = () => {
    if (name === "Company Nannies") {
      setShowContact(true);
      return; // stop — do not navigate
    }
    navigate("/add-booking-details", {
      state: { categoryName: name, categoryImage: image, categoryId, price },
    });
  };

  return (
    <>
      <div className="col-lg-4 col-md-6 mb-4">
        <div className="nannay_cat_main d-block shadow bg-body rounded overflow-hidden">
          <Link onClick={navigateToAnotherScreen}>
            <div className="category_image">
              <img src={image} className="w-100" alt={name} />
            </div>
            <div className="px-2 pt-2 categoty_heading w-100 d-flex justify-content-between align-items-center">
              <h6 className="m-0">{name}</h6>
              <Link to="#" className="arrow_right">
                <ArrowRightAltIcon />
              </Link>
            </div>
          </Link>
        </div>
      </div>

      {/* ── Company Nannies contact modal ── */}
      <Modal
        show={showContact}
        onHide={() => setShowContact(false)}
        centered
        className="company-nannies-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Contact Us — Company Nannies</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="contact-intro">
            To book a Company Nanny, please reach out to us directly via any of
            the channels below and our team will assist you.
          </p>

          <ul className="contact-list">
            <li>
              <EmailIcon className="contact-icon contact-icon--email" />
              <div>
                <span className="contact-label">Email</span>
                <a href={`mailto:${COMPANY_NANNIES_CONTACT.email}`}>
                  {COMPANY_NANNIES_CONTACT.email}
                </a>
              </div>
            </li>

            <li>
              <WhatsAppIcon className="contact-icon contact-icon--whatsapp" />
              <div>
                <span className="contact-label">WhatsApp</span>
                <a
                  href={`https://wa.me/${COMPANY_NANNIES_CONTACT.whatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Chat on WhatsApp
                </a>
              </div>
            </li>

            <li>
              <PhoneIcon className="contact-icon contact-icon--phone" />
              <div>
                <span className="contact-label">Phone</span>
                <a href={`tel:${COMPANY_NANNIES_CONTACT.whatsapp}`}>
                  {COMPANY_NANNIES_CONTACT.phone}
                </a>
              </div>
            </li>
          </ul>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowContact(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Card;
